import { useHistory } from 'react-router-dom';

import Typography from '@mui/material/Typography';

import { RecipeListObject } from '../../app/commonSelector';
import { SearchFilteredRecipesInterface } from '../../app/search/search.types';
import { useAppSelector } from '../../app/store/hooks';
import useLogRecipeEdit from '../../hooks/useLogRecipeEdit';
import { EventLogsEnum } from '../../utils/events';
import { SeeAllArrow } from '../../utils/iconRefs/recipePageIcons';
import RecipeCard from '../recipeCard';
import styles from "./homepageCategory.module.css";
import { COMPONENTS, HOMEPAGE_ROW_TYPE, SOURCE } from './utils/constants';

const filteredCategoryRecipes = (recipeIds: string[], recipesListMap: any) => {
  const filteredRecipes: SearchFilteredRecipesInterface[] = [];
  // TODO: need to fix this asap, 
  // there should be never a check for recipeIds,
  // since the data should be santiized beforehand 
  if (!recipeIds) return filteredRecipes;
  for (let i = 0; i < recipeIds.length; i += 1) {
    const recipe = recipesListMap[recipeIds[i]];
    if (recipe) {
      filteredRecipes.push(recipe);
    }
  }
  return filteredRecipes;
}

const HomepageCategory = ({ categoryId, homePageRow, viewedHomePageRow }: { categoryId: string, homePageRow: number, viewedHomePageRow: number }) => {
  const history = useHistory();
  const { logRecipeEdit } = useLogRecipeEdit();
  const categoryToRecipeId = useAppSelector((state) => state.homepage.categoryToRecipeId);
  const recipesListMap = useAppSelector(RecipeListObject)

  const recipeIds = categoryToRecipeId[categoryId]?.recipeIds;
  const categoryName = categoryToRecipeId[categoryId]?.categoryName;
  const recipes = filteredCategoryRecipes(recipeIds, recipesListMap);

  if (recipes.length === 0) return null;

  const onCategoryLinkClick = () => {
    logRecipeEdit(EventLogsEnum.APP_LISTVIEW_OPENED, {
      eventData: { homePageRow, viewedHomePageRow, homePageRowType: HOMEPAGE_ROW_TYPE.CATEGORY, componentDetails: COMPONENTS.CATEGORY, categoryId }
    })

    const url = `/filter/?Category_ID=${categoryId}&title=${categoryName}&source=category`;
    history.push(url);
  }

  return (
    <div className={styles.category_container} id={`category_container-${categoryId}`}>
      <div className={styles.category_header} id={`category-header-${categoryId}`}>
        <Typography className={styles.header_name} id={`category-${categoryName}`} variant='captionparalell' >{categoryName}</Typography>
        <div className={styles.link_style} id={`see-all-link-${categoryId}`} onClick={onCategoryLinkClick}><Typography id={`see-all-text-${categoryId}`} variant='ingredientText2mini'>See all</Typography><SeeAllArrow /></div>
      </div>
      <div className={styles.swiper_container} id={`recipes-container-${categoryId}`}>
        {recipes.map((recipe: SearchFilteredRecipesInterface, index: number) => (
          <div className={styles.slide} id={`recipe-card-for-${recipe?.id}`} key={recipe?.id}>
            <RecipeCard
              homePageRow={homePageRow}
              homePageRowType='category'
              recipe={recipe}
              source={SOURCE.HOMEPAGE}
              viewedHomePageRow={viewedHomePageRow} 
              viewedHomePageColumn={index} 
              />
          </div>
        ))}
      </div>
    </div>
  )
}

export default HomepageCategory;
